import BrbForm from './BrbForm.vue'
import BrbInput from './BrbInput.vue'
import BrbSelect from './BrbSelect.vue'
import BrbUploader from './brb-uploader/index.vue'
import BrbDateTimeDisplay from './BrbDateTimeDisplay.vue'
import BrbDateTimePicker from './BrbDateTimePicker.vue'
import BrbBtn from './BrbBtn.vue'
import BrbMedia from './BrbMedia.vue'
import BrbLabelValue from './BrbLabelValue.vue'
import BrbCurrencyDisplay from './BrbCurrencyDisplay.vue'
import BrbListWrapper from './BrbListWrapper.vue'
import BrbPagination from '@/components/shared/brb-components/BrbPagination.vue'
import BrbEmptyView from '@/components/shared/brb-components/BrbEmptyView.vue'
import BrbModal from '@/components/shared/brb-components/BrbModal.vue'
import BrbTabs from '@/components/shared/brb-components/BrbTabs.vue'

export default {
  BrbForm,
  BrbInput,
  BrbSelect,
  BrbUploader,
  BrbDateTimeDisplay,
  BrbDateTimePicker,
  BrbBtn,
  BrbMedia,
  BrbLabelValue,
  BrbCurrencyDisplay,
  BrbListWrapper,
  BrbPagination,
  BrbEmptyView,
  BrbModal,
  BrbTabs
}
